import React from "react";
import { CircularProgress } from "@mui/material";

const SectionLoaderOverlay = () => (
  <div style={{
    position: "absolute", inset: 0, minHeight: 200, display: "flex",
    alignItems: "center", justifyContent: "center",
    background: "rgba(255, 255, 255, 0.72)", zIndex: 5
  }}>
    <CircularProgress size={44} />
  </div>
);

export default SectionLoaderOverlay;
